module.exports = __webpack_public_path__ + "img/f_twitter.708a7458.svg";